import * as React from "react";
import { hot } from "react-hot-loader";
import { Redirect } from 'react-router-dom';
import DataProviderSharePoint from '../../../dataproviders/DataProvidersSharePoint';
import EnmUtils from '../../../utils/EnmUtils';
import { IPromotionsListProps } from './IPromotionsListProps';
import { IPromotionInfos, IPromotionsListState } from './IPromotionsListState';
declare var configcustoms: any;
declare var libelle: any;

class PromotionsList extends React.Component<IPromotionsListProps, IPromotionsListState> {

  private _dataProvider = new DataProviderSharePoint();

  constructor(props: IPromotionsListProps) {
    super(props);

    const promotionInfosInit: IPromotionInfos[] = [];

    this.props.promotionsList.map((promotion) => {
      promotionInfosInit[promotion.Id] = {
        alreadyCandidate: this.promotionHaveAlreadyCandidature(promotion.Id),
      }
    });

    this.state = {
      RedirectTo: '',
      DisabledBtn: false,
      PromotionInfos: promotionInfosInit,
    }
  }

  public render() {

    if (this.state.RedirectTo !== '') {
      return (
        <Redirect to={this.state.RedirectTo} />
      );
    }

    const promotionsRender = this.props.promotionsList.map((promotion, index) => {
      return (
        <div key={index} className="custom-card mb-2">
          <div className="p-4 d-flex flex-nowrap flex-column flex-sm-row justify-content-between align-items-center">
            <div>
              <h4 className="text-secondary">{promotion.Titre}</h4>
              <p><b>{libelle.promotionsList.dateCandidature}</b> {EnmUtils.getDateFrAddOneDay(promotion.DateOuverture)} > {EnmUtils.getDateFrAddOneDay(promotion.DateFermeture)}</p>
              <p className="mb-0"><b>{libelle.promotionsList.annee}</b> {promotion.Annee}</p>
            </div>
            <div>
              <button type="button" className="btn btn-primary btn-lg" disabled={this.state.DisabledBtn || this.state.PromotionInfos[promotion.Id].alreadyCandidate}
                onClick={this.createCandidatureAndRedirect.bind(this, promotion.Id)}>
                {libelle.promotionsList.btnCreateCandidature}
              </button>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="row pt-4">
        <div className="col-12">
          <h1>{libelle.promotionsList.title}</h1>
          <div className="mt-3">
            {promotionsRender}
          </div>
        </div>
      </div>
    );
  }

  private createCandidatureAndRedirect(idPromotion: number) {
    const idCandidatureKey = "IdCandidature";
    this.setState({ DisabledBtn: true });
    this._dataProvider.createCandidature(this.props.ConnectedLogin, idPromotion).then(res => {
      if (res[idCandidatureKey] != null) {

        this._dataProvider.sendInput(this.props.ConnectedLogin, res[idCandidatureKey], "IdPromo", '' + idPromotion, "Text").then(respIdPromo => {
          this._dataProvider.sendInput(this.props.ConnectedLogin, res[idCandidatureKey], "EtatCandidature", this.props.EtatCandidatureList[0], "Choice").then(respEtatCandidature => {
            this._dataProvider.sendInput(this.props.ConnectedLogin, res[idCandidatureKey], "EtatDepotCandidature", this.props.EtatDepotCandidatureList[0], "Choice").then(respEtatDepot => {
              this.setState({ DisabledBtn: true, RedirectTo: configcustoms.Route.Formulaire + '?idCandidature=' + res[idCandidatureKey] });
            });
          });
        });


      } else {
        this.setState({ DisabledBtn: false });
      }
    });
  }

  private promotionHaveAlreadyCandidature(idPromotion: number): boolean {
    let promotionHaveCandidature = false;

    this.props.candidaturesList.map(candidature => {
      if (candidature.IdPromo === '' + idPromotion) {
        promotionHaveCandidature = true;
        return;
      }
    });

    return promotionHaveCandidature;
  }

}

export default hot(module)(PromotionsList);
